import { render, staticRenderFns } from "./jgjc.vue?vue&type=template&id=31892a16&scoped=true&"
import script from "./jgjc.vue?vue&type=script&lang=js&"
export * from "./jgjc.vue?vue&type=script&lang=js&"
import style0 from "./jgjc.vue?vue&type=style&index=0&id=31892a16&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31892a16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31892a16')) {
      api.createRecord('31892a16', component.options)
    } else {
      api.reload('31892a16', component.options)
    }
    module.hot.accept("./jgjc.vue?vue&type=template&id=31892a16&scoped=true&", function () {
      api.rerender('31892a16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/scyxDrawer/components/jgjc.vue"
export default component.exports